namespace $.$$ {
	
	$mol_style_define( $shm_projects_catalog, {
		
		Menu_page: {
			flex: {
				basis: '14rem',
				grow: 0,
				shrink: 0,
			},
		},

		Projects: {
			flex: {
				direction: 'column',
			},
		},

		Project_link: {
			position: 'relative',
			boxSizing: 'border-box',
			width: '100%',
			overflow: 'visible',
		},

		Project_title: {
			flex: {
				basis: 'auto',
				grow: 1,
				shrink: 1,
			},
			width: '100%',
			minWidth: 0,
		},

		Project_type: {
			margin: 0,
			lineHeight: '1',
			color: $mol_theme.shade,
			background: { color: $mol_theme.card },
			boxShadow: 'none',
		},

		New_project_form: {
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.block,
		},

		New_project_actions: {
			gap: $mol_gap.text,
			flex: {
				wrap: 'wrap',
			},
		},
		
	} )
	
}
